import { AsyncPipe } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { Observable, of } from "rxjs";

import { TagComponent } from "@hermes/aphrodite/tag";
import {
    PersoFeatureFlippingKey,
    FeatureFlagFacade,
} from "@hermes/states/flipper";
import {
    BELTKIT,
    NOT_SUPPORTED,
    ProductCategory,
    SMALL_LEATHER_GOODS,
} from "@hermes/states/personalization-page";

@Component({
    standalone: true,
    imports: [TagComponent, AsyncPipe],
    selector: "h-personalize-label[persoProductType]",
    templateUrl: "./personalize-label.component.html",
    styleUrls: ["./personalize-label.component.scss"],
})
export class PersonalizeLabelComponent implements OnInit {
    @Input()
    public persoProductType: ProductCategory | undefined;

    /** True if the feature flipping is activated */
    public displayPersoLabel$!: Observable<boolean>;

    constructor(private featureFlagFacade: FeatureFlagFacade) {}

    public ngOnInit(): void {
        if (this.persoProductType) {
            this.displayPersoLabel$ = this.isPersoActivated(
                this.persoProductType,
            );
        }
    }

    private isPersoActivated(
        persoProductType: ProductCategory,
    ): Observable<boolean> {
        const flag = {
            [BELTKIT]: PersoFeatureFlippingKey.beltkit_key,
            [SMALL_LEATHER_GOODS]: PersoFeatureFlippingKey.pm_key,
            [NOT_SUPPORTED]: undefined,
        }[persoProductType];

        return flag ? this.featureFlagFacade.isActivated(flag) : of(false);
    }
}
